// ─── Feuille : CRÉATION / ÉDITION d'un lieu de rangement ──────────
// Extrait d'EcranPlans (découpage). Nom + parent (« ranger dans », liste
// aplatie sans la propre descendance du lieu) + icône. L'écriture reste au
// parent (enregistrerEmp — brouillon de plan ou arbre en base).
import React, { useMemo } from 'react';
import { Text, TextInput, TouchableOpacity } from 'react-native';
import { Feuille, SelecteurEmoji, useUI, useT } from '@mop/core';
import { cheminDe } from './services/inventaires';
import { makeStylesPlans } from './stylesPlans';

export default function FeuilleLieu({
  fEmp, setFEmp, pickParent, setPick, empModifie, enregistrerEmp, fermerFormEmp,
  empPlat, exclus, emplacements, planTitre,
}) {
  const UI = useUI();
  const t = useT();
  const s = useMemo(() => makeStylesPlans(UI), [UI]);
  return (
    <Feuille visible={!!fEmp} titre={fEmp?.id ? t('lieux.modifierTitre') : t('lieux.nouveauTitre')} emoji="📍"
      onFermer={fermerFormEmp}
      action={{ icone: fEmp?.id ? '💾' : '＋', onPress: enregistrerEmp, disabled: !empModifie, label: t('commun.enregistrer') }}>
      {pickParent ? (
        <>
          <Text style={s.lbl}>{t('plans.rangerDans')}</Text>
          <TouchableOpacity style={[s.parent, !fEmp?.nouveauParentId && s.parentOn]}
            onPress={() => { setFEmp(x => ({ ...x, nouveauParentId: null })); setPick(false); }}>
            <Text style={s.parentTxt}>🏠 {planTitre || t('inventaire.plan')} {t('plans.racineSuffixe')}</Text>
          </TouchableOpacity>
          {empPlat.filter(o => !exclus.has(o.id)).map(o => (
            <TouchableOpacity key={o.id} style={[s.parent, fEmp?.nouveauParentId === o.id && s.parentOn]}
              onPress={() => { setFEmp(x => ({ ...x, nouveauParentId: o.id })); setPick(false); }}>
              <Text style={s.parentTxt}>{'   '.repeat(o.profondeur)}{o.emoji || '📍'} {o.nom}</Text>
            </TouchableOpacity>
          ))}
        </>
      ) : (
        <>
          <Text style={s.lbl}>{t('listes.nom')}</Text>
          <TextInput style={s.input} value={fEmp?.nom || ''}
            onChangeText={(v) => setFEmp(x => ({ ...x, nom: v }))}
            placeholder={t('plans.phNomLieu')} placeholderTextColor={UI.faint} />

          <Text style={s.lbl}>{t('plans.rangerDansCourt')}</Text>
          <TouchableOpacity style={s.parent} onPress={() => setPick(true)}>
            <Text style={s.parentTxt}>
              {fEmp?.nouveauParentId
                ? cheminDe(emplacements, fEmp.nouveauParentId)
                : `🏠 ${planTitre || t('inventaire.plan')} ${t('plans.racineSuffixe')}`}
            </Text>
            <Text style={s.chev}>›</Text>
          </TouchableOpacity>

          <Text style={s.lbl}>{t('profil.icone')}</Text>
          <SelecteurEmoji inline avecRecherche valeur={fEmp?.emoji || '📍'}
            onChange={(e) => setFEmp(x => ({ ...x, emoji: e }))} />
        </>
      )}
    </Feuille>
  );
}
